import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebookF, FaTwitter, FaYoutube, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./common.css";

const Footer = () => {
  return (
    <footer className="gov-footer">

      <div className="container">
        <div className="row gy-4">

          {/* Portal Info */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand-header mb-3">
              <h5 className="footer-title">मंचाबद्दल</h5>
            </div>
            <p className="footer-text">
              नागरिकांच्या तक्रारी निवारण, शासकीय योजनांची माहिती,
              व जनसंवाद प्रक्रियेसाठी सुलभ व पारदर्शक डिजिटल मंच.
              आपल्या समस्या आमचे प्राधान्य आहे.
            </p>
            <div className="social-icons mt-4">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-4 col-md-6">
            <h5 className="footer-title">त्वरित दुवे</h5>
            <ul className="list-unstyled footer-links">
              <li><Link to="/">📌 मुख्यपृष्ठ</Link></li>
              <li><Link to="/about_us">📌 आमच्याबद्दल</Link></li>
              <li><Link to="/schemes">📌 सर्व योजना</Link></li>
              <li><Link to="/complaint">📌 तक्रार नोंदवा</Link></li>
              {/* <li><Link to="/suggestions">📌 नागरिक सुझाव</Link></li> */}
              <li><Link to="/gallery">📌 छायाचित्र गॅलरी</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-lg-4 col-md-12">
            <h5 className="footer-title">संपर्क केंद्र</h5>
            <div className="footer-contact-info">
              <p className="footer-text d-flex align-items-center gap-2">
                <FaMapMarkerAlt className="text-saffron" /> मुख्य जनसंपर्क कार्यालय, महाराष्ट्र राज्य
              </p>
              <p className="footer-text d-flex align-items-center gap-2">
                <FaEnvelope className="text-saffron" /> support@nagrikseva.in
              </p>
              <p className="footer-text d-flex align-items-center gap-2">
                <FaPhoneAlt className="text-saffron" /> १८००-२३३-४५६७ (टोल फ्री)
              </p>
            </div>
            <div className="mt-3 p-3 rounded-3 bg-dark-glass border-glass">
              <small className="text-light opacity-75 d-block">कार्यालयीन वेळ: सकाळी १०:०० ते सायंकाळी ६:०० (सोमवार ते शनिवार)</small>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom */}
      <div className="gov-footer-bottom">
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between gap-2">
          <span>© २०२६ भारतीय जनता पक्ष नागरिक सेवा मंच | सर्व हक्क राखीव</span>
          <span className="text-saffron-light">पारदर्शक आणि जलद प्रशासनासाठी सदैव कार्यरत</span>
        </div>
      </div>

    </footer>
  );
};

export default Footer;


